import request from '@/utils/request'

export function fetchTalentTask(data) {
  return request({
    baseURL: '/chaos/api',
    url: '/v1/activity/new/talent/task',
    method: 'post',
    data: data
  })
}


// 新秀养成-我的奖励
export function fetchTalentAward(data) {
  return request({
    baseURL: '/chaos/api',
    url: '/v1/activity/new/talent/award',
    method: 'post',
    data: data
  })
}

// 是否开通赞赏

// 新秀养成-我的奖励
export function fetchDonateState(data) {
  return request({
    baseURL: '/chaos/api',
    url: '/v1/donate/activate/state',
    method: 'post',
    data: data
  })
}


// 新秀养成-我的上月奖励
export function fetchTalentNotify(data) {
  return request({
    baseURL: '/chaos/api',
    url: '/v1/activity/new/talent/award/notify',
    method: 'post',
    data: data
  })
}



// WEBPACK FOOTER //
// ./src/views/activity_170/api.js